import './instrument'; // initialize Sentry first!

import React from 'react';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';

import { App } from './App';
import { initializeI18n } from './i18n';

// Use an async IIFE to ensure i18n is initialized before rendering
(async () => {
  await initializeI18n();

  const root = ReactDOM.createRoot(document.getElementById('root')!, {
    // catch unhandled errors
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
      console.warn('Uncaught error', error, errorInfo.componentStack);
    }),

    // caught errors
    onCaughtError: Sentry.reactErrorHandler(),

    // catch errors handled by React
    onRecoverableError: Sentry.reactErrorHandler(),
  });

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
})();
